var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E169C",
    fillRule: "evenodd",
    d: "M5 13.438c.863 0 1.563.7 1.563 1.562v10a.937.937 0 0 0 .937.938h15a.94.94 0 0 0 .938-.938V15a1.563 1.563 0 0 1 3.125 0v10a4.06 4.06 0 0 1-4.063 4.063h-15A4.06 4.06 0 0 1 3.438 25V15c0-.863.7-1.562 1.562-1.562M13.895 1.395c.61-.61 1.6-.61 2.21 0l5 5a1.563 1.563 0 0 1-2.21 2.21L15 4.71l-3.895 3.895a1.563 1.563 0 0 1-2.21-2.21z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E169C",
    fillRule: "evenodd",
    d: "M15 .938c.863 0 1.563.7 1.563 1.562v16.25a1.563 1.563 0 0 1-3.125 0V2.5c0-.863.7-1.562 1.562-1.562",
    clipRule: "evenodd"
  })));
};
export default SvgUpload;